import React, { useContext, useEffect, useState, useMemo } from 'react'
import { AppContext } from 'stores/AppStore'
import { useTranslation } from 'react-i18next'
import { UserContext } from 'stores/UserStore'
import { VallourecServicesDataContext } from 'stores/VallourecServicesDataStore'
import { FlexView, Icon, LoadingOverlay } from 'components/common'
import { useHistory } from 'react-router-dom'
import { exportAsExcelFile } from 'utils/excel'
import { FaFileExcel } from 'react-icons/fa'
import FilteredTable from 'components/common/FilteredTable'
import moment from 'moment'

const VallourecServicesTagsPage = () => {

  const DEFAULT_URL = "vallourec-services-tags"
  const { t } = useTranslation()
  const history = useHistory()
  const { registryLog } = useContext(UserContext)
  const { setPageSubtitle } = useContext(AppContext)
  const {
    specificList,
    getSpecificList,
    loadingLista,
    infoSpecific,
    pieceSpecific
  } = useContext(VallourecServicesDataContext)
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setPageSubtitle(t('vallourecServicesData.pageTitle'))
  }, [setPageSubtitle, t])

  useEffect(() => {
    (async () => { await getSpecificList(1) })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [specificList])

  const columns = useMemo(() => {
    const result = []
    result.push({
      Header: t('vallourecServicesData.ippn'),
      accessor: 'ippn',
      customHeaderProps: { style: { width: 'auto' } },
      customCellProps: { style: { width: 'auto' } },
    })
    result.push({
      Header: t('vallourecServicesData.valid'),
      accessor: 'valid',
      customHeaderProps: { style: { width: 'auto' } },
      customCellProps: { style: { width: '110px' } },
    })
    result.push({
      Header: t('vallourecServicesData.part_number'),
      accessor: 'part_number',
      customHeaderProps: { style: { width: 'auto' } },
      customCellProps: { style: { width: '110px' } },
    })
    result.push({
      Header: t('vallourecServicesData.dsc_actual_material'),
      accessor: 'dsc_actual_material',
      customHeaderProps: { style: { width: 'auto' } },
      customCellProps: { style: { width: '100px' } },
    })
    result.push({
      Header: t('vallourecServicesData.od_nominal_mm'),
      accessor: 'od_nominal_mm',
      customHeaderProps: { style: { width: 'auto' } },
      customCellProps: { style: { width: '100px' } },
      disableFilters: true
    })
    result.push({
      Header: t('vallourecServicesData.wt_nominal_mm'),
      accessor: 'wt_nominal_mm',
      customHeaderProps: { style: { width: 'auto' } },
      customCellProps: { style: { width: '120px' } },
      disableFilters: true
    })
    result.push({
      Header: t('vallourecServicesData.id_nominal_mm'),
      accessor: 'id_nominal_mm',
      customHeaderProps: { style: { width: 'auto' } },
      customCellProps: { style: { width: '120px' } },
      disableFilters: true
    })
    result.push({
      Header: t('vallourecServicesData.lb_ft'),
      accessor: 'lb_ft',
      customHeaderProps: { style: { width: 'auto' } },
      customCellProps: { style: { width: 'auto' } },
      disableFilters: true
    })
    result.push({
      Header: t('vallourecServicesData.weight_kg'),
      accessor: 'weight_kg',
      customHeaderProps: { style: { width: 'auto' } },
      customCellProps: { style: { width: '100px' } },
      disableFilters: true
    })
    result.push({
      Header: t('vallourecServicesData.length_mm'),
      accessor: 'length_mm',
      customHeaderProps: { style: { width: 'auto' } },
      customCellProps: { style: { width: '100px' } },
      disableFilters: true
    })
    result.push({
      Header: t('vallourecServicesData.sales_order'),
      accessor: 'sales_order',
      customHeaderProps: { style: { width: 'auto' } },
      customCellProps: { style: { width: '100px' } },
    })
    result.push({
      Header: t('vallourecServicesData.sales_order_item'),
      accessor: 'sales_order_item',
      customHeaderProps: { style: { width: 'auto' } },
      customCellProps: { style: { width: '100px' } },
      disableFilters: true
    })
    result.push({
      Header: t('vallourecServicesData.purchase_order'),
      accessor: 'purchase_order',
      customHeaderProps: { style: { width: 'auto' } },
      customCellProps: { style: { width: '120px' } },
    })
    result.push({
      Header: t('vallourecServicesData.purchase_order_item'),
      accessor: 'po_item',
      customHeaderProps: { style: { width: 'auto' } },
      customCellProps: { style: { width: '100px' } },
      disableFilters: true
    })
    result.push({
      Header: t('vallourecServicesData.dt_manufacture'),
      accessor: 'dt_manufacture',
      Cell: ({ cell: { value } }) => value ? moment.utc(value).format('DD/MM/YYYY') : '',
      customHeaderProps: { style: { width: 'auto' } },
      customCellProps: { style: { width: '100px' } },
      sortType: 'date',
      disableFilters: true
    })
    result.push({
      Header: t('vallourecServicesData.supplier'),
      accessor: 'supplier',
      customHeaderProps: { style: { width: 'auto' } },
      customCellProps: { style: { width: '100px' } },
    })
    result.push({
      Header: t('vallourecServicesData.dsc_project'),
      accessor: 'dsc_project',
      customHeaderProps: { style: { width: 'auto' } },
      customCellProps: { style: { width: '100px' } },
      disableFilters: true
    })
    result.push({
      Header: t('vallourecServicesData.num_certificate'),
      accessor: 'num_certificate',
      customHeaderProps: { style: { width: 'auto' } },
      customCellProps: { style: { width: '100px' } },
      disableFilters: true
    })
    result.push({
      Header: t('vallourecServicesData.certificate_version'),
      accessor: 'certificate_version',
      customHeaderProps: { style: { width: 'auto' } },
      customCellProps: { style: { width: '100px' } },
      disableFilters: true
    })
    result.push({
      Header: t('vallourecServicesData.drift_diameter_mm'),
      accessor: 'drift_diameter_mm',
      customHeaderProps: { style: { width: 'auto' } },
      customCellProps: { style: { width: '100px' } },
      disableFilters: true
    })
    result.push({
      Header: t('vallourecServicesData.make_up_loss_mm'),
      accessor: 'make_up_loss_mm',
      customHeaderProps: { style: { width: 'auto' } },
      customCellProps: { style: { width: '100px' } },
      disableFilters: true
    })
    result.push({
      Header: t('vallourecServicesData.grease_type'),
      accessor: 'grease_type',
      customHeaderProps: { style: { width: 'auto' } },
      customCellProps: { style: { width: '100px' } },
    })
    result.push({
      Header: t('vallourecServicesData.dt_expiration'),
      accessor: 'dt_expiration',
      Cell: ({ cell: { value } }) => value ? moment.utc(value).format('DD/MM/YYYY') : '',
      customHeaderProps: { style: { width: 'auto' } },
      customCellProps: { style: { width: '150px' } },
      sortType: 'date',
      disableFilters: true
    })
    result.push({
      Header: t('vallourecServicesData.dt_operation'),
      accessor: 'dt_operation',
      Cell: ({ cell: { value } }) => value ? moment.utc(value).format('DD/MM/YYYY') : '',
      customHeaderProps: { style: { width: 'auto' } },
      customCellProps: { style: { width: '110px' } },
      disableFilters: true
    })
    return result
  }, [t])

  const onExcelExport = () => {
    // registryLogOld('Excel Export', DEFAULT_URL)
    registryLog(DEFAULT_URL, 'click', 'export_excel')
    if (pieceSpecific) {
      setLoading(true)
      const reportData = []
      for (const data of pieceSpecific) {
        const obj = {}
        for (const key of Object.keys(data)) {
          obj[t('vallourecServicesData.' + key)] = data[key]
        }
        reportData.push(obj)
      }
      exportAsExcelFile(reportData, 'Vallourec Services - ' + infoSpecific.list_name)
      setTimeout(() => {
        setLoading(false)
      }, 3000)
    }
  }

  const onBack = () => {
    history.push('/vallourec-services-data')
  }

  return (
    <>
      <FlexView flex="1" position="relative" alignSelf="stretch">
        <FlexView margin="10px 20px 4px" flexDirection="row" justifyContent="space-between" alignSelf="stretch" alignItems="center">
          <FlexView flexDirection="row" alignItems="center" justifyContent="flex-start" alignSelf="stretch" margin="16px">
            <Icon name='arrow-left' width="30px" height="30px" onClick={onBack} style={{cursor: "pointer"}} tooltip='Go back'/>
            <FlexView fontSize="big" fontWeight="bold" color="gray" margin="0px 8px 0px 8px">{t('vallourecServicesData.selectedItem')} {infoSpecific.list_name}</FlexView>
          </FlexView>
          <FlexView flexDirection="row" margin="10px 20px 4px" alignItems="center" justifyContent="flex-end" flex="1">
            <FaFileExcel
              style={{
                width: "30px",
                height: "30px",
                color: "#777777",
                margin: "0 10px 0 0",
                cursor: "pointer",
              }}
              margin="0px 8px 0px 0px"
              title={t('fieldData.excelExport')}
              onClick={onExcelExport} />
          </FlexView>
        </FlexView>
        <FlexView margin="10px 20px 4px" flexDirection="column" justifyContent="space-between" alignSelf="stretch" alignItems="center">
          <FilteredTable data={pieceSpecific} columns={columns} />
        </FlexView>
      </FlexView>
      <LoadingOverlay visible={loadingLista || loading} />
    </>
  )

}

export default VallourecServicesTagsPage
